import { render, staticRenderFns } from "./default.vue?vue&type=template&id=e2dbd7fe&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=e2dbd7fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuLateral: require('/home/ubuntu/bejuco/web/components/menu-lateral.vue').default,DialogReload: require('/home/ubuntu/bejuco/web/components/dialogReload.vue').default,DialogLoader: require('/home/ubuntu/bejuco/web/components/DialogLoader.vue').default,Logo: require('/home/ubuntu/bejuco/web/components/logo.vue').default})
